export default __webpack_public_path__ + "40a0666c6e21ab795182a809c504cbb1.svg";